<div class="tw-min-h-screen tw-bg-slate-50 tw-py-12 tw-px-4">
  <div class="tw-max-w-4xl tw-mx-auto">

    <!-- Header -->
    <div class="tw-mb-8">
      <h1 class="tw-text-2xl tw-font-bold tw-text-slate-900">
        {{ usuario.role === 'candidato' ? 'Mis Postulaciones' : 'Candidatos Postulados' }}
      </h1>
      <p class="tw-mt-1 tw-text-slate-500 tw-text-sm">
        {{ usuario.role === 'candidato'
          ? 'Historial de vacantes a las que te has postulado'
          : 'Candidatos que aplicaron a tus vacantes' }}
      </p>
    </div>

    <!-- Search -->
    <form [formGroup]="formBus" (ngSubmit)="buscarPostulados()"
          class="tw-flex tw-gap-3 tw-mb-6">
      <input type="text" formControlName="buscador"
             (input)="buscarPostulados()"
             placeholder="Buscar por título de vacante..."
             class="tw-flex-1 tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200
                    tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none
                    focus:tw-border-blue-400 tw-transition">
      <button type="submit"
              class="tw-px-5 tw-py-2.5 tw-rounded-xl tw-bg-blue-600 tw-text-white
                     tw-text-sm tw-font-semibold tw-border-0 tw-cursor-pointer tw-transition
                     hover:tw-bg-blue-700">
        Buscar
      </button>
    </form>

    <!-- ═══════════ VISTA CANDIDATO ═══════════ -->
    <ng-container *ngIf="usuario.role === 'candidato'">

      <!-- Empty -->
      <div *ngIf="!postulaciones?.length"
           class="tw-text-center tw-py-16 tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100">
        <svg class="tw-mx-auto tw-w-10 tw-h-10 tw-text-slate-300 tw-mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12"/>
        </svg>
        <p class="tw-text-slate-500 tw-text-sm">No tienes postulaciones aún.</p>
        <a routerLink="/vacantes"
           class="tw-inline-block tw-mt-4 tw-px-5 tw-py-2 tw-rounded-xl tw-bg-blue-600
                  tw-text-white tw-text-sm tw-font-semibold tw-transition"
           style="text-decoration:none">
          Explorar vacantes
        </a>
      </div>

      <!-- Cards -->
      <div class="tw-space-y-3">
        <div *ngFor="let p of postulaciones | paginate: { itemsPerPage: 10, currentPage: noPagina }"
             class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-5"
             style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
          <div class="tw-flex tw-items-start tw-justify-between tw-gap-4">
            <div class="tw-flex-1 tw-min-w-0">
              <h3 class="tw-text-sm tw-font-semibold tw-text-slate-800 tw-leading-snug tw-truncate">
                {{ p.nombreVacante }}
              </h3>
              <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-mt-1.5">
                <span class="tw-text-xs tw-text-slate-500">{{ p.nombreEmpresa }}</span>
                <span *ngIf="p.lugar" class="tw-text-xs tw-text-slate-400">· {{ p.lugar }}</span>
                <span class="tw-text-xs tw-text-slate-400">· {{ p.fecha | appDate:'dd/MM/yyyy' }}</span>
              </div>
            </div>
            <span class="tw-px-2.5 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold tw-flex-shrink-0"
                  [style.background]="p.status === 'Cerrada' ? '#fef2f2' : p.status === 'Visto' ? '#eff6ff' : '#f0fdf4'"
                  [style.color]="p.status === 'Cerrada' ? '#dc2626' : p.status === 'Visto' ? '#1d4ed8' : '#16a34a'">
              {{ p.status || 'Pendiente' }}
            </span>
          </div>
        </div>
      </div>

      <div class="tw-mt-6 tw-flex tw-justify-center" *ngIf="postulaciones?.length > 10">
        <pagination-controls (pageChange)="noPagina = $event"
                             [responsive]="true" [previousLabel]="''" [nextLabel]="''">
        </pagination-controls>
      </div>
    </ng-container>

    <!-- ═══════════ VISTA EMPRESA ═══════════ -->
    <ng-container *ngIf="usuario.role === 'empresa'">

      <!-- Empty -->
      <div *ngIf="!postulacionesEmpresa?.length"
           class="tw-text-center tw-py-16 tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100">
        <svg class="tw-mx-auto tw-w-10 tw-h-10 tw-text-slate-300 tw-mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"/>
        </svg>
        <p class="tw-text-slate-500 tw-text-sm">Aún no hay candidatos postulados.</p>
      </div>

      <!-- Cards -->
      <div class="tw-space-y-3">
        <div *ngFor="let p of postulacionesEmpresa | paginate: { itemsPerPage: 10, currentPage: noPagina }"
             class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-5"
             style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
          <div class="tw-flex tw-items-start tw-justify-between tw-gap-4">

            <!-- Info -->
            <div class="tw-flex-1 tw-min-w-0">
              <p class="tw-text-xs tw-text-slate-400 tw-truncate tw-mb-0.5">{{ p.nombreVacante }}</p>
              <a routerLink="/candidatos/detalles/{{p.idCandidato}}"
                 class="tw-text-sm tw-font-semibold tw-text-slate-800 hover:tw-text-blue-600 tw-transition"
                 style="text-decoration:none">
                {{ p.nombrePostulado }}
              </a>
              <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-mt-1.5">
                <span *ngIf="p.correoPostulado" class="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-slate-500">
                  <svg class="tw-w-3.5 tw-h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"/>
                  </svg>
                  {{ p.correoPostulado }}
                </span>
                <span *ngIf="p.telefonoPostulado" class="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-slate-500">
                  <svg class="tw-w-3.5 tw-h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"/>
                  </svg>
                  {{ p.telefonoPostulado }}
                </span>
                <span *ngIf="p.paisPostulado" class="tw-text-xs tw-text-slate-400">{{ p.paisPostulado }}</span>
                <span class="tw-text-xs tw-text-slate-400">{{ p.fechaPostulacion | appDate:'dd/MM/yyyy' }}</span>
              </div>
            </div>

            <!-- Status select -->
            <div class="tw-flex-shrink-0">
              <select (change)="actualizarEstatus(p.idPostulacion, $event.target.value)"
                      class="tw-text-xs tw-font-semibold tw-px-3 tw-py-1.5 tw-rounded-full tw-border-0
                             tw-outline-none tw-cursor-pointer tw-transition"
                      [style.background]="p.estatus === 'Cerrada' ? '#fef2f2' : p.estatus === 'Visto' ? '#eff6ff' : '#f0fdf4'"
                      [style.color]="p.estatus === 'Cerrada' ? '#dc2626' : p.estatus === 'Visto' ? '#1d4ed8' : '#16a34a'">
                <option hidden selected disabled [value]="null">{{ p.estatus || 'Pendiente' }}</option>
                <option *ngFor="let s of estatus" [value]="s">{{ s }}</option>
              </select>
            </div>

          </div>
        </div>
      </div>

      <div class="tw-mt-6 tw-flex tw-justify-center" *ngIf="postulacionesEmpresa?.length > 10">
        <pagination-controls (pageChange)="noPagina = $event"
                             [responsive]="true" [previousLabel]="''" [nextLabel]="''">
        </pagination-controls>
      </div>
    </ng-container>

  </div>
</div>
